var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.519 40.0367L28.1272 40.0016L51.2811 17.6804C52.1897 16.796 52.6897 15.6215 52.6897 14.372C52.6897 13.1226 52.1897 11.9481 51.2811 11.0636L47.4686 7.35281C45.6512 5.58396 42.4806 5.59332 40.6777 7.34579L17.519 29.6716V40.0367ZM44.0695 10.6612L47.8892 14.365L44.0503 18.0665L40.2378 14.358L44.0695 10.6612ZM22.3267 31.623L36.8219 17.6477L40.6344 21.3585L26.1416 35.3291L22.3267 35.3408V31.623Z",
    fill: "#407F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7115 49.3654H46.3653C49.0168 49.3654 51.173 47.2666 51.173 44.6859V24.405L46.3653 29.0845V44.6859H20.3028C20.2403 44.6859 20.1754 44.7093 20.1129 44.7093C20.0336 44.7093 19.9543 44.6882 19.8726 44.6859H12.7115V11.9295H29.1706L33.9783 7.25H12.7115C10.0601 7.25 7.90381 9.34875 7.90381 11.9295V44.6859C7.90381 47.2666 10.0601 49.3654 12.7115 49.3654Z",
    fill: "#407F84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileIcon);
export default __webpack_public_path__ + "static/media/EditProfileIcon.6f8147e67abced83d5327da652ae1ac9.svg";
export { ForwardRef as ReactComponent };